import { render, staticRenderFns } from "./MiniviewQuestions.vue?vue&type=template&id=5b095ccf"
import script from "./MiniviewQuestions.vue?vue&type=script&lang=js"
export * from "./MiniviewQuestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports